import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Abhishek Choubey',
    title: "Full Stack Web Developer",
    desciption:"Everybody wants to be famous, but nobody wants to do the work. You grind hard so you can play hard. At the end of the day after putting all the efforts , your hard work'll pay off",
    image: 'https://cloud1.ipupload.com/cache/plugins/filepreviewer/14815/c87fa1bc230c59dad98c9d4de85ffc03749b9f0a9de33bc9a42691292abe04fd/1100x800_cropped.jpg',
    resumePdf: "https://drive.google.com/file/d/1V06bz-_980ndbeOItwPOtR3nI2eF1sqR/view?usp=sharing"
}
